import React, { Fragment } from 'react'
import { useHistory } from 'react-router-dom'
import AddIcon from '@material-ui/icons/Add'
import { List, useListRepository } from 'elentari'
import { riscoRepository } from './RiscoRepository'
import { useAbility } from '../Usuarios'
import { Tooltip } from 'recharts'
import { Fab } from '@material-ui/core'
import { getListActions } from '../../lib/crudAuthorization'

export const RiscoTable = ({ classes, onClickNew, ...props }) => {
  const history = useHistory()

  const listHook = useListRepository({
    repository: riscoRepository,
    path: 'riscos'
  })

  const [ability] = useAbility()
  const actions = getListActions(ability, listHook, 'riscos')

  const listOptions = {
    defaultOrder: 'id',
    fields: {
      id: {
        label: 'Id'
      },
      numero: {
        label: 'Número'
      },
      descricao: {
        label: 'Descrição'
      }
    }
  }

  const handleClickEdit = item =>
    history.push(`/riscos/${item.id}${history.location.search}`)

  return (
    <Fragment>
      <List
        {...props}
        {...listHook}
        {...actions}
        stickyHeader
        adjustToScreenHeight
        onClickEdit={handleClickEdit}
        onClickView={null}
        removeItem={null}
        hideDownloadIcon
        listOptions={listOptions}
      />
      <Tooltip title="Adicionar">
        <Fab
          aria-label="Adicionar"
          color="primary"
          onClick={onClickNew}
          size="small"
        >
          <AddIcon size={24} color="inherit" />
        </Fab>
      </Tooltip>
    </Fragment>
  )
}
